import "katex/dist/katex.min.css";

import type { FC } from "react";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import Latex from "react-latex-next";

import { GenericBox, PrintAttachmentBox } from "components";
import { AssignmentImage } from "components/AssignmentImage";

import type { UserAssignmentDetailFragment } from "api/generated";

import { extractFileNameFromPath } from "utils/extractFileNameFromPath";
import { useAssetUrlResolver } from "utils/hooks/useAssetUrlResolver";

interface Props {
  userAssignment: UserAssignmentDetailFragment;
  onSubmit: () => void;
}

const Task: FC<Props> = ({ userAssignment, onSubmit }) => {
  const assignment = userAssignment.assignment?.assignment;

  const { t } = useTranslation(["assignments"]);

  const imageUrl = useAssetUrlResolver(assignment?.assignmentImage);
  const printAttachmentUrl = useAssetUrlResolver(assignment?.printingAttachment);

  return (
    <div className="exercise__body">
      <div className="d-flex flex-column gap-3">
        <Latex>{assignment?.assignmentText ?? ""}</Latex>
        {!!assignment?.assignmentImage && (
          <AssignmentImage
            src={imageUrl}
            alt=""
            thumbHash={assignment?.assignmentImageThumbHash}
            width={assignment?.AssignmentImageDimensions?.width}
            height={assignment?.AssignmentImageDimensions?.height}
          />
        )}

        <Latex>{assignment?.questionsText ?? ""}</Latex>

        {assignment?.questions.map((question, qIndex) => (
          <div key={qIndex} className="mt-20px ">
            <Latex>{question.heading ?? ""}</Latex>
          </div>
        ))}
      </div>

      <div>
        {printAttachmentUrl !== null ? (
          <PrintAttachmentBox
            printAttachmentURL={printAttachmentUrl}
            pdfName={extractFileNameFromPath(assignment?.printingAttachment)}
          />
        ) : (
          <GenericBox />
        )}

        <div className="exercise__footer">
          <div className="mw-sm px-3">
            <Button className={"w-100 text-uppercase"} onClick={onSubmit}>
              {t("detail.submitSelfEvaluation", { ns: "assignments" })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Task;
